import { extendTheme } from "@mui/joy/styles";
import { createTheme } from "@mui/material/styles";
import createCache from "@emotion/cache";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";

export const configs = {
  base_url_img:
    process.env.REACT_APP_MEDIA_BASE_URL || "http://localhost:8001/",
  sweet_alert_config: {
    showCancelButton: true,
    showConfirmButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "بله",
    cancelButtonText: "خیر",
  },
  chart_url:
    process.env.REACT_APP_CHART_URL ||
    "http://localhost:8000/api/generate-chart-url/",
  chart_render_payload_url: "/v1/charts/render-payload/",
  chart_direct_embed_flag_url: "/v1/charts/flags/direct-embed/",
  chart_global_market_metrics_url: "/v1/charts/market-metrics/global/",
  chart_persistence_save_url: "/v1/charts/persistence/save/",
  chart_persistence_load_url: "/v1/charts/persistence/load/",
  charting_library_static_base_url:
    process.env.REACT_APP_CHARTING_LIBRARY_STATIC_BASE_URL ||
    "http://localhost:8000/static/charting_app/",
  chart_datafeed_url:
    process.env.REACT_APP_CHART_DATAFEED_URL || "http://localhost:3003",
  chart_force_direct_embed:
    process.env.REACT_APP_CHART_FORCE_DIRECT_EMBED || "0",
  chart_direct_embed_kill_switch:
    process.env.REACT_APP_CHART_DIRECT_EMBED_KILL_SWITCH || "0",
  site_key: "6LdEMT0aAAAAADSKO-fMVWFBWYcXPzXrsf8LDqoy",
};

export const rtlCache = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

export const ltrCache = createCache({
  key: "mui",
});

export const theme = createTheme({
  typography: {
    fontFamily: '"Vazir", sans-serif',
  },
  components: {
    MuiSelect: {
      styleOverrides: {
        select: {
          textAlign: "right",
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          justifyContent: "flex-end",
        },
      },
    },
  },
});

export const joyTheme = extendTheme({
  fontFamily: {
    body: '"Vazir", sans-serif',
  },
});
